import styled from 'styled-components';

const TableItemStyle = styled.div`
	--detailsItemMBot: var(--sp5x);

	&.tableWrap {
		opacity: 0;
		--linkTopMargin: var(--sp3x);

		&.underline {
			&:first-child {
				// border-top: 2px solid var(--color2);
			}
		}

		&:first-child {
			padding-top: 0;
		}

		&:last-child {
			padding-bottom: 0;
		}

		&.count {
			.title {
				position: relative;
				padding-left: var(--sp2-5x);

				&:before {
					position: absolute;
					counter-increment: my-sec-counter;
					content: '0' counter(my-sec-counter);
					left: 0;
					top: calc(var(--sp2-5x) * -1);
					font-weight: var(--ffRegular);
					font-family: var(--fontFamily2);
					font-size: var(--p);
				}
			}
		}

		&.one-item {
			padding-top: var(--titleToText);
		}

		.animationWrap {
			position: relative;
			margin-top: var(--sp11x);
			padding-top: 35%;
			z-index: -1;
		}

		.detailsWrap {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			margin-bottom: calc(-1 * var(--detailsItemMBot));

			.detailsItem {
				opacity: 0;
				width: 45%;
				margin-bottom: var(--detailsItemMBot);
			}
		}

		.awards-text {
			margin-top: var(--detailsItemMBot);
		}

		.extensionsWrap {
			padding-left: var(--sp8x);

			.extensions {
				opacity: 0;
				margin-top: var(--sp2-5x);
				margin-bottom: var(--sp4x);
			}

			.link-m-top {
				margin-top: var(--sp5x);
			}

			.link {
				position: relative;
				text-decoration: underline;
				color: var(--color2);

				&:after {
					content: '*';
					font-style: normal;
					font-weight: var(--ffSemiBold);
					position: absolute;
					top: 0;
					left: 0;
					transform: translate3d(-100%, -20%, 0);
				}
			}
		}

		.minContent {
			p {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 6;
				overflow: hidden;
				box-sizing: border-box;
				white-space: pre-line;
			}
		}

		.listWrap {
			padding-left: var(--sp9x);

			li {
				display: flex;
				margin-bottom: var(--sp4x);
				line-height: normal;

				&:before {
					content: '*';
					font-weight: var(--ffSemiBold);
					margin-right: var(--sp1x);
				}
			}
		}

		.title {
			position: relative;
			opacity: 0;
			z-index: -1;
		}

		.m-top {
			margin-top: var(--linkTopMargin);
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
			.title {
				margin-bottom: var(--sp3x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.MobileSize}) {
			.extensionsWrap {
				padding-left: var(--sp10x);

				.extensions {
					margin-top: var(--sp2-5x);
					margin-bottom: var(--sp4x);
				}
			}

			.listWrap {
				padding-left: var(--sp12x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.extensionsWrap {
				padding-left: var(--sp10x);

				.extensions {
					margin-top: var(--sp10x);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--linkTopMargin: var(--sp4x);
			--detailsItemMBot: var(--sp8x);

			display: flex;
			flex-wrap: wrap;

			.title {
				padding-right: var(--sp3x);
				flex: 0 0 48%;
			}

			.description {
				flex: 1;

				p {
					-webkit-line-clamp: 4;
				}
			}

			&.count {
				.title {
					padding-left: var(--sp3x);
				}
			}

			.extensionsWrap {
				padding-left: 0;

				.extensions {
					margin-top: var(--sp4x);
				}
			}

			.listWrap {
				padding-left: 0;
			}

			.animationWrap {
				margin-top: var(--sp3x);
				padding-top: 50%;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.listWrap {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				li {
					flex: 0 0 48%;
					max-width: 48%;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--linkTopMargin: var(--sp5x);

			.title {
				flex: 0 0 51%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			.minWidth {
				flex: 0 0 42%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.title {
				flex: 0 0 53%;
			}

			.listWrap {
				li {
					&:before {
						margin-right: var(--sp2x);
					}
				}
			}

			.minWidth {
				flex: 0 0 43%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--detailsItemMBot: var(--sp10x);

			.extensionsWrap {
				.extensions {
					margin-top: var(--sp5x);
				}
			}

			.animationWrap {
				padding-top: 32%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			.listWrap {
				li {
					&:before {
						margin-right: var(--sp3x);
					}
				}
			}

			.minWidth {
				max-width: 36%;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--linkTopMargin: var(--sp8x);
			--detailsItemMBot: var(--sp12x);

			&.count {
				.title {
					padding-left: var(--sp4x);
				}
			}

			.listWrap {
				li {
					margin-bottom: var(--sp5x);

					&:before {
						margin-right: var(--sp3x);
					}
				}
			}

			.minWidth {
				flex: 0 0 39%;
			}
		}
	}
`;

export default TableItemStyle;
